import React, { Component } from 'react'
import CreateVersion from './CreateVersion'
import ViewVersion from './ViewVersion'
import setTitle from "../../../helpers/TitleComponent";
import { getCookie, getAccessToken } from "../../../helpers/cookieHelper";
import { API_URL } from '../../../constants';
import { Messager } from 'rc-easyui';
import { getFormattedDate } from "../../../helpers";
import { getUserId } from "../../../helpers/AuthHelper";

const axios = require("axios");
export default class VersionDetail extends Component {
    constructor() {
        super()
        this.childRef = React.createRef()
        this.state = {
            vers: {
                createdBy: '',
                enabled: "",
                version: "",
                versionEndDate: '',
                versionStartDate: ''
            },
            vData: [],
            rules: {
                // enabled: ['required'],
                version: ['required'],
            },
            enableStatus: [
                { "value": true, "text": "Active" },
                { "value": false, "text": "Inactive" }
            ],
            operation: "Add",
            selected: {},
            permissions: [],
        }
    }

    componentDidMount = () => {
        var data = getCookie('permission');
        this.setState({
            permissions: JSON.parse(data),
            vers: {
                enabled: true,
                version: "",
                createdBy: getUserId(),
                versionEndDate: new Date(),
                versionStartDate: new Date()
            }
        },
            function () {
                setTitle('Project Info. Entry')
                // this.getVersion()
            }
        );
    }



    handleChange = (name, value) => {
        const newArr = { ...this.state.vers }
        newArr[name] = value
        this.setState({
            vers: newArr

        })

    }
    // formClear=()=> {
    //     let clearTicket = {
    //          priority:""
    //     };
    //     this.setState({
    //         prioirty: clearTicket,
    //         operation: "Add",
    //       },
    //       function () {
    //            this.childRef.current.validate((errors) => {});
    //                   }
    //               );
    //   }
    // OnEditClick = () => {
    //     var rules = this.state.rules;
    //     console.log(this.state.selected);
    //     if (this.state.selected != null) {

    //         this.setState({
    //             rules: rules,
    //             priority: this.state.selected,
    //             operation: "Update",
    //         });

    //         const timer = setTimeout(() => {
    //             this.childRef.current.validate((errors) => { });
    //         }, 100);
    //         return () => clearTimeout(timer);
    //     }
    // }
    OnEditClick = (row) => {
        let form = { ...this.state.vers }
        row.versionStartDate=new Date(row.versionStartDate)
        row.versionEndDate=new Date(row.versionEndDate)
        this.setState({
            vers: row
        }, () => {
            this.setState({
                operation: 'operation'
            })
        })
    }

    // deleteRow = (row) => {
    //     this.setState({
    //         vers: this.state.vers.filter(r => r !== row)
    //     })
    // }

    onSelectionChange = (selectedRow) => {
      
        this.setState({
            selected: selectedRow,
        });
    }

    // getVersion = async () => {
    //     let erp_access_token = getCookie('access_token')
    //     let erp_token_type = getCookie('token_type')
    //     let headerConfig = {
    //         headers: {
    //             authorization: erp_token_type + ' ' + erp_access_token,
    //             'Content-Type': 'application/json',
    //         },
    //     }
    //     //   console.log(erp_access_token)
    //     if (erp_access_token != null) {
    //         this.setState({
    //             isLoading: true,
    //         })
    //         let url = API_URL + 'api/fetchallversion';
    //         axios.get(url, headerConfig)
    //             .then((response) => {
    //                 console.log(response);
    //                 if (response.status === 200) {
    //                     var dataObject = response.data.object

    //                     this.setState({
    //                         vData: dataObject
    //                     })

    //                 } else {
    //                     this.setState({
    //                         vData: [],
    //                     })
    //                 }
    //             })
    //             .catch((error) => {
    //                 this.setState({
    //                     vData: [],
    //                 })
    //                 // alert ("Internal server error");
    //                 let response = error['response']
    //                 if (response !== undefined) {
    //                     this.messager.alert({
    //                         title: 'Error',
    //                         icon: 'error',
    //                         reload: false,
    //                         msg: response.data.message
    //                     })//Backend Validation Error i.e. 403
    //                 } else {
    //                     this.messager.alert({
    //                         title: 'Error',
    //                         icon: 'error',
    //                         msg: 'Internal Server Error',
    //                         reload: false,
    //                     })// Caused due to syntax error in front end
    //                 }
    //             })
    //     } else {
    //         const resp = await getAccessToken()
    //         if (resp) {
    //             this.getVersion()
    //         }
    //     }
    // }

    render() {
        const { permissions } = this.state;
        return (
            <div>
                <Messager ref={ref => this.messager = ref}></Messager>

                <div className='container-fluid'>
                    <div className='row'>
                        {permissions.includes("create-user-group-create") ? (
                            <div className='col-4'>
                                <CreateVersion
                                    vers={this.state.vers}
                                    handleChange={this.handleChange}
                                    operation={this.state.operation}
                                    rules={this.state.rules}
                                    ref={this.childRef}
                                    formClear={this.formClear}
                                    enableStatus={this.state.enableStatus} />
                            </div>
                        ) :
                            ''
                        }

                        {permissions.includes("create-user-group-view") ? (
                            <div className='col-8'>
                                <ViewVersion
                                    OnEditClick={this.OnEditClick}
                                    onSelectionChange={this.onSelectionChange}
                                    selectedRow={this.state.selected}
                                    permissions={this.state.permissions}
                                    deleteRow={this.deleteRow}
                                />
                            </div>
                        ) :
                            ''
                        }
                    </div>
                </div>
            </div>
        )
    }
}
